interface HexGridProps {
  className?: string;
  opacity?: number;
}

/**
 * Retícula hexagonal decorativa (leitmotiv "el panal del descubrimiento").
 * Se renderiza absolutamente sobre el contenedor padre. El padre debe ser `relative overflow-hidden`.
 */
export function HexGrid({ className = "", opacity = 0.18 }: HexGridProps) {
  return (
    <svg
      className={`absolute inset-0 -z-10 h-full w-full pointer-events-none ${className}`}
      viewBox="0 0 1200 600"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      style={{ opacity }}
    >
      <defs>
        <pattern id="hex-pattern" x="0" y="0" width="86" height="100" patternUnits="userSpaceOnUse">
          <polygon
            points="43,4 80,25 80,75 43,96 6,75 6,25"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </pattern>
      </defs>
      <rect width="1200" height="600" fill="url(#hex-pattern)" />
    </svg>
  );
}
